<template>
  <div
    style="height:100%;background-color: rgb(153, 204, 204,0.2);padding: 14px 20px;box-sizing: border-box;"
  >
    <h2 align="center" style="color: #3b3b3b;">日工作信息表</h2>
    <el-row>
      <div class="block" width="50%" style="display:inline-block;float:left">
        <data-time @datachange="timechange"></data-time>
        <div style="display:inline-block">
          <el-button
            type="danger"
            size="small"
            @click="checkedDelete"
            v-if="timeFlag=='open'&& yshangban=='1'"
          >
            批量删除
            <i class="el-icon-delete"></i>
          </el-button>
          <el-button
            size="small"
            @click="handleAdd"
            type="primary"
            v-if="timeFlag=='open' && yshangban == '1'"
          >新增工作记录</el-button>
        </div>
      </div>
      <div style="display:inline-block;float:right">
        <el-button @click="exportToExcel" size="small" type="success">导出表格</el-button>
        <el-button size="small" @click="tuichu" type="primary">《《 退出登录</el-button>
      </div>
    </el-row>
    <get-table
      ref="diaoyong"
      :CtableData.sync="tableData"
      @getData="getstage"
      :CtimeFlag.sync="timeFlag"
      :Cyshangban.sync="yshangban"
      style="height:74%"
    ></get-table>
  </div>
</template>
<script>
import DataTime from "@/base/DataTime";
import GetTable from "./GetTable";
import axios from "axios";
import { showLoading, hideLoading } from "@/lib/loading";
import {
  hourToMin,
  getTaskOptionValue,
  getOptionStrName,
  gettasklistStrName,
  saveAndout,
  gettaskOptions,
  getpsheList,
  sfwork
} from "@/lib/until";
export default {
  name: "person",
  components: {
    DataTime,
    GetTable
  },
  data() {
    return {
      nowtime: "",
      personId: "",
      tableData: [],
      timeFlag: "",
      yshangban: 1,
      notifyPromise: Promise.resolve(),
      ceshi: []
    };
  },
  created() {
    this.getuserInfo();
    this.testNotify();
  },
  methods: {
     append(data) {
        const newChild = { id: id++, label: 'testtest', children: [] };
        if (!data.children) {
          this.$set(data, 'children', []);
        }
        data.children.push(newChild);
      },

      remove(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      },
      renderContent(h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
            <span>
              <el-button size="mini" type="text" on-click={ () => this.append(data) }>Append</el-button>
              <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>Delete</el-button>
            </span>
          </span>);
      },
    //通知，解决element-ui，同时调用notify时，通知重叠的问题
    notify(msg) {
      // this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
      this.$notify({
        message: msg,
        dangerouslyUseHTMLString: true,
        duration: 3000,
        position: "top-right",
        showClose: false,
        offset: 180
      });
      // });
    },

    testNotify() {
      //var array = ["好开心", "不高兴", "爱你哦", "你昨天的日志未填满8个小时"];
      axios
        .get(IPConfig.IP + "/kpi-management/alert/alert_msg.php", {
          params: {
            employee_id: this.personId
          }
        })
        .then(res => {
          //console.log(555);
          //console.log(res.data);
          if (0 == res.data.errcode) {
            var noteList = res.data.employee_check_list;
            var ceshi = [];
            var ding = setInterval(() => {
              // console.log(array.length)
              if (noteList.length > 0) {
                this.notify(noteList[0]);
                noteList.shift(0, 1);
                //console.log(array);
              } else {
                clearInterval(ding);
              }
            }, 1000);
          }
        });
    },
    getstage(base) {
      //base_info 传进来
      //console.log(base);
      this.base_info = base;
    },
    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.depart_id = uesrInfo.depart_ID;
      this.personId = uesrInfo.employee_id;
      this.password = uesrInfo.password;
      //console.log(this.depart_id);
    },
    exptime(data1) {
      axios
        .get(IPConfig.IP + "/kpi-management/ppdata/paydate.php")
        .then(res => {
          //console.log(res.data);
          if (0 == res.data.errcode) {
            if (
              res.data.payment_create_dates &&
              res.data.payment_create_dates.length > 0
            ) {
              var KpiDayList = res.data.payment_create_dates;
              var LastDay = KpiDayList[0];
              var oDate1 = new Date(data1);
              var oDate2 = new Date(LastDay);
              //var oDate2 = new Date('2020-05-24');
              if (oDate1.getTime() < oDate2.getTime()) {
                this.timeFlag = "close";
              } else {
                this.timeFlag = "open";
              }
            }
          }
        })
        .catch(error => {
          //console.log(error);
        });
    },

    timechange(time) {
      //console.log(time);

      sfwork(time).then(res => {
        console.log('---可用时间--',res)
        this.yshangban = res;
      });
      this.exptime(time);
      axios
        .get(IPConfig.IP + "/kpi-management/info/daily_report_info.php", {
          params: {
            employee_id: this.personId,
            daily_report_date: time,
            //params: { encodeout: "utf-8" }

          }
        })
        .then(data => {
          showLoading();
          //console.log(data.data);
          this.tableData = [];
          var searchMsg = data.data;

          var valueList = Object.values(searchMsg.daily_report_list);
          //console.log(valueList);
          this.search(valueList);
        })
        .catch(error => {
          //console.log(error);
          hideLoading();
        });
    },
    search(getDailyMsg) {
      if (typeof getDailyMsg == "undefined" || getDailyMsg.length <= 0) {
        hideLoading();
      }
      //console.log(this.base_info.project_list);
      var tableDataList = [];
      var base_info = this.base_info;
      for (var i = 0; i < getDailyMsg.length; i++) {
        let vms = getDailyMsg[i];
        //获取部门名字
        for (let key in this.base_info.depart_list) {
          //console.log(key);
          if (vms.depart_id == key) {
            vms["bumencn"] = this.base_info.depart_list[key].depart_name;
          }
        }
        //获取阶段名字
        for (let key in this.base_info.project_list) {
          if (vms.project_id == key) {
            vms["xiangmucn"] = this.base_info.project_list[key].project_name_cn;
          }
        }

        getpsheList(vms).then(res => {
          //console.log(vms);
          vms["chioes"] = gettaskOptions(vms.depart_id, this.base_info, res);
          let chioseList = vms["chioes"];
          vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
          console.log(vms);
          var taskoptions = this.base_info.depart_all_task_list[vms.depart_id];
          var scopeName = [];
          Object.assign(scopeName, vms["value1"]);
          if (scopeName.length > 0) {
            vms["task_name_str"] = gettasklistStrName(
              vms.task_id,
              scopeName,
              taskoptions
            );
          } else {
            vms["task_name_str"] = vms.task_id;
          }

          hourToMin(vms);
          tableDataList.push(vms);
          tableDataList = Object.values(tableDataList).sort(function(a, b) {
            return a.phase_id - b.phase_id;
          });
          this.tableData = tableDataList;
          // this.tableData.push(vms);
          //console.log(this.tableData);
          hideLoading();
        });
      }
      //console.log(this.tableData);
    },
    tuichu() {
      saveAndout(this);
    },
    exportToExcel() {
      this.$refs.diaoyong.exportToExcel();
    },
    handleAdd() {
      this.$refs.diaoyong.AddEmtyData();
    },
    checkedDelete() {
      this.$refs.diaoyong.checkedDelete();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/PersonWork/index.vue